import axios from "axios";
import authHeader from "./authentification-header";

const API_URL = "/api/v1/oidc";

const getLogin = () => axios
    .get(API_URL + "/login")
    .then(response => response.data);

const getInfo = (key) => axios
    .post(API_URL + `/info/${key}`, {}, { headers: authHeader() })
    .then(response => response.data);

const getSignout = () => axios
    .post(API_URL + "/signout", {}, { headers: authHeader() })
    .then(response => response.data);

const allActions = {
    getLogin,
    getInfo,
    getSignout
};

export default allActions;